import {DeepgramClient} from '@deepgram/sdk';
import { AGENT_API_BASE_URL } from '@/shared/constants';
import { getAccessToken } from '@/shared/api/clients/tokenAccessor';

const DEPGRAM_MODEL = "nova-3";

export const useLiveVoiceTranscription = () => {
    const getDeepgramAccessToken = async () => {
        let authHeaders: Record<string, string> = {};
        try {
          const token = await getAccessToken();
          authHeaders = { Authorization: `Bearer ${token}` };
        } catch {
          // Token not available — proceed without auth
        }
        
        const response = await fetch(`${AGENT_API_BASE_URL}/transcriptionToken`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...authHeaders,
          },
        });
        if (!response.ok) {
          throw new Error(
            `Failed to fetch Deepgram transcription token (HTTP ${response.status})`,
          );
        }
        const data = await response.json();
        if (!data?.access_token) {
          throw new Error('Transcription token response missing access_token');
        }
        return data.access_token;
    }

    const getDeepgramSocketConnection = async () => {
        const accessToken = await getDeepgramAccessToken();
        const deepgram = new DeepgramClient({ accessToken });
        const socket = await deepgram.listen.v1.connect({
            model: DEPGRAM_MODEL,
            encoding: "opus",
            punctuate: "true",
            interim_results: "true",
            Authorization: `Bearer ${accessToken}`
        });
        return socket;
    }

    return { getDeepgramSocketConnection };
};